import * as $ from 'jquery';

export default class OrderFormController {

  constructor() {

    let $showDeliveryAddressButton = $('.js-showDeliveryAddressButton');
    let $enableDeliveryAddressBlock = $('.js-enableDeliveryBlock');
    this.addListener($showDeliveryAddressButton);
    this.addEnableDeliveryBlockListener($enableDeliveryAddressBlock);
  }

//TO DO: Listener implementieren siehe in altem projekt

  addListener($showDeliveryAddressButton) {
    $showDeliveryAddressButton.click(() => {
      $('.js-deliveryAdressBlock').toggleClass('hide');
      if ($('.js-enableDeliveryBlock').val() === '0') {
        $('.js-enableDeliveryBlock').val(1);
      } else {
        $('.js-enableDeliveryBlock').val(0);
      }
      const elements = document.querySelectorAll('div.js-deliveryAdressBlock div.js-required input, select');
      for (let i = 0; i < elements.length; i++) {
        const test = elements[i];
        if (test instanceof HTMLInputElement) {
          test.required = !test.required;
        }
      }
    });
  }

  addEnableDeliveryBlockListener($enableDeliveryAddressBlock) {
    if ($enableDeliveryAddressBlock.val() === '1' && $('.js-deliveryAdressBlock').hasClass('hide')) {
      $('.js-deliveryAdressBlock').removeClass('hide');
    }
  }
}
